import React, { useCallback, useState } from 'react'
import flowRight from 'lodash/flowRight'
import { useMount } from 'react-nb-hooks'
import { LKDate } from 'loankeeper-common/helpers/Date'

import LKGrid from '../LKGrid'
import LKModal, { LKModalContainer, LKModalTrigger } from '../LKModal'

import translate, { translateLKMessage } from './translate'
import { useDispatch } from 'react-redux'
import { AppDispatch, ThunkApi } from 'src/store/index.d'
import { destroy } from '../LKGrid'
import { actions as LKModalActions } from '../LKModal'
import { AsyncThunk } from '@reduxjs/toolkit'

export const HISTORY_MODAL = 'HISTORY_MODAL'
export const HISTORY_GRID = 'HISTORY_GRID'

type HistoryModalProps = {
  action: AsyncThunk<unknown, any, ThunkApi>
  params?: Record<string, any>
  modalInstanceName?: string
}

const LKGridconfig = {
  gridIdentity: {
    formName: 'frm_auth_loanevent_history',
    objectName: 'dbgrd_history',
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnDefs: [
    { headerName: 'AuthTypeID', field: 'AuthTypeID' },
    { headerName: 'AuthDate', field: 'AuthDate' },
    { headerName: 'LoginFull', field: 'LoginFull' },
    { headerName: 'AuthType', field: 'AuthType' },
  ],

  columnConfigs: {
    AuthDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toTString(),
    },
    AuthTypeID: {
      iconComponent: (value) => {
        switch (Number(value)) {
          case 1:
            return 'bullet_red'
          case 2:
            return 'bullet_green'
          default:
            return undefined
        }
      },
    },
  },
}

const HistoryModal = (props: HistoryModalProps) => {
  const { modalInstanceName, action, params } = props
  const dispatch = useDispatch<AppDispatch>()

  const [history, setHistory] = React.useState([])
  const [loading, setLoading] = useState(false)

  const handleModalClose = useCallback(() => {
    dispatch(destroy(HISTORY_GRID))
  }, [dispatch])

  const getHistory = useCallback(async () => {
    setLoading(true)
    const response = await dispatch(action(params))
    if (!action.fulfilled.match(response)) {
      dispatch(LKModalActions.openInfo(translateLKMessage(response.payload as string)))
      setLoading(false)
      return
    }
    setHistory(response.payload as any[])
    setLoading(false)
  }, [action, dispatch, params])

  useMount(() => {
    getHistory()

    return () => {
      handleModalClose()
    }
  })

  return (
    //@ts-ignore
    <LKModal
      icon="footprint"
      heading={translate('frm_auth_loanevent_history')}
      name={modalInstanceName}
      onClose={handleModalClose}
      loading={loading}
      size="xxs"
    >
      <LKGrid instanceName={HISTORY_GRID} rowData={history} {...LKGridconfig} />
    </LKModal>
  )
}

HistoryModal.defaultProps = {
  loading: true,
}

export const HistoryModalTrigger = ({ disabled, ...restProps }) => (
  //@ts-ignore
  <LKModalTrigger disabled={disabled} params={restProps} alias="footprint" name={HISTORY_MODAL} />
)

export default flowRight(LKModalContainer(HISTORY_MODAL), React.memo)(HistoryModal)
